import './scss/index.scss';
import ComponentsFactory from 'foundation/components-factory';
import LiveNavigationComponent from './js/live-navigation.component';

ComponentsFactory.getInstance().define('live-navigation', LiveNavigationComponent);
